import store from "@packages/store";
import Case from "case";
import Vue from "vue";

export default {
    async list({ key, pagination, filters, method }) {
        const leads = method
            ? await Vue.api[key][method]({ pagination, filters })
            : await Vue.api[key].list({ pagination, filters });

        store.commit(`${Case.upper(key)}_SET_LIST`, leads);

        return leads;
    },

    async count({ key, filters, countMethod }) {
        const count = countMethod
            ? await Vue.api[key][countMethod]({ filters })
            : await Vue.api[key].count({ filters });

        store.commit(`${Case.upper(key)}_SET_COUNT`, count);

        return count;
    },
};
